import {Box, Typography} from "@mui/material";

const MEDIA_MAX_1450 = "@media (max-width: 1450px)";
const MEDIA_MAX_1200 = "@media (max-width: 1200px)";
const MEDIA_MAX_1023 = "@media (max-width: 1023px)";

const answerTextSx = {
    fontSize: "17px",
    fontWeight: 400,
    lineHeight: 1.2,
    textAlign: "start",
    [MEDIA_MAX_1450]: {
        fontSize: "16px",
    },
    [MEDIA_MAX_1200]: {
        fontSize: "15px",
    },
    [MEDIA_MAX_1023]: {
        fontSize: "17px",
    },
};

function renderParts(parts) {
    return parts.map((part, index) => (
        <Box
            key={index}
            component="span"
            sx={{
                fontWeight: part.bold ? 700 : "inherit",
                fontStyle: part.italic ? "italic" : "normal",
            }}
        >
            {part.text}
        </Box>
    ));
}

export function FaqAnswerContent({content}) {
    if (!content?.length) {
        return null;
    }

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                pt: "10px",
                width: "100%",
                [MEDIA_MAX_1450]: {
                    pt: "8px",
                    gap: "8px",
                },
                [MEDIA_MAX_1200]: {
                    pt: "6px",
                    gap: "6px",
                },
                [MEDIA_MAX_1023]: {
                    pt: "10px",
                    gap: "10px",
                },
            }}
        >
            {content.map((block, blockIndex) => {
                if (block.type === "paragraph") {
                    return (
                        <Typography
                            key={blockIndex}
                            component="p"
                            sx={{
                                ...answerTextSx,
                                m: 0,
                            }}
                        >
                            {renderParts(block.parts)}
                        </Typography>
                    );
                }

                if (block.type === "list") {
                    return (
                        <Box
                            key={blockIndex}
                            component="ul"
                            sx={{
                                m: 0,
                                pl: "20px",
                                display: "flex",
                                flexDirection: "column",
                                gap: "6px",
                            }}
                        >
                            {block.items.map((item, itemIndex) => (
                                <Typography
                                    key={itemIndex}
                                    component="li"
                                    sx={{
                                        ...answerTextSx,
                                        display: "list-item",
                                    }}
                                >
                                    {renderParts(item.parts)}
                                </Typography>
                            ))}
                        </Box>
                    );
                }

                return null;
            })}
        </Box>
    );
}

export default FaqAnswerContent;
